import { render, staticRenderFns } from "./actionRemarksModal.vue?vue&type=template&id=84bb9348&scoped=true&"
import script from "./actionRemarksModal.vue?vue&type=script&lang=js&"
export * from "./actionRemarksModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84bb9348",
  null
  
)

export default component.exports